import { useState } from 'react';

import { ModalBase } from '../../../components/modals/ModalBase';

import type React from 'react';

export interface CapabilityOverrideModalProps {
  open: boolean;
  isPending: boolean;
  failed: boolean;
  outcome: string | null;
  onClose: () => void;
  onConfirm: (args: { effectiveUntil: string; approvalNote?: string }) => void;
}

/** Tipo 5 — capability temporária: datetime-local → ISO8601, validado no futuro (D4). */
export function CapabilityOverrideModal({
  open,
  isPending,
  failed,
  outcome,
  onClose,
  onConfirm,
}: CapabilityOverrideModalProps): React.JSX.Element | null {
  const [until, setUntil] = useState('');
  const [note, setNote] = useState('');
  if (!open) return null;

  // `datetime-local` devolve "YYYY-MM-DDTHH:mm" (sem timezone). Interpretado como local.
  const parsed = until === '' ? null : new Date(until);
  const isFuture = parsed !== null && !Number.isNaN(parsed.getTime()) && parsed.getTime() > Date.now();
  const canSubmit = isFuture && !isPending;

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Aprovar capability temporária"
      width={500}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className="btn-ghost-mini" type="button" onClick={onClose} disabled={isPending}>
            Cancelar
          </button>
          <button
            className="btn-ghost-mini btn-ghost-mini--primary"
            type="button"
            disabled={!canSubmit}
            onClick={() => {
              if (parsed === null) return;
              onConfirm({
                effectiveUntil: parsed.toISOString(),
                ...(note.trim() === '' ? {} : { approvalNote: note.trim() }),
              });
            }}
          >
            {isPending ? 'Aprovando…' : 'Aprovar c/ prazo'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <label className="modal-form__field">
          <span className="modal-form__label">Válida até (obrigatório · data/hora futura)</span>
          <input
            className="modal-form__input"
            type="datetime-local"
            value={until}
            onChange={(e) => setUntil(e.target.value)}
          />
          {until !== '' && !isFuture && (
            <span className="modal-form__hint" style={{ color: 'var(--danger-fg)' }}>
              A data precisa estar no futuro.
            </span>
          )}
        </label>
        <label className="modal-form__field">
          <span className="modal-form__label">Nota de aprovação (opcional)</span>
          <textarea
            className="modal-form__textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={2}
          />
        </label>
        {failed && (
          <div className="banner banner--danger" role="alert">
            <div className="banner__body">
              <span className="banner__title">Não foi possível aprovar a capability temporária.</span>
            </div>
          </div>
        )}
        {outcome !== null && (
          <div className="modal-form__callout" role="status">
            {outcome}
          </div>
        )}
      </div>
    </ModalBase>
  );
}
